import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

// Importar y registrar el locale español
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import localeEsExtra from '@angular/common/locales/extra/es';

// Registrar el locale con sus datos adicionales
registerLocaleData(localeEs, 'es-ES', localeEsExtra);

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
